function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useState } from 'react';
import * as R from 'unitx/ramda';
export default ((position = {
  x: 0,
  y: 0
}) => {
  const [state, setState] = useState({
    position,
    startPosition: {
      x: 0,
      y: 0
    },
    isDown: false
  });

  const onDown = startPosition => setState(_objectSpread(_objectSpread({}, state), {}, {
    isDown: true,
    startPosition
  }));

  const onMove = currentPosition => R.when(R.pipe(R.prop('isDown'), R.isNotNil), setState(_objectSpread(_objectSpread({}, state), {}, {
    position: _objectSpread(_objectSpread({}, state.position), {}, {
      x: state.startPosition.x - currentPosition.x,
      y: state.startPosition.y - currentPosition.y
    })
  })))(state);

  const onUp = () => setState(_objectSpread(_objectSpread({}, state), {}, {
    isDown: false
  }));

  return {
    onDown,
    onMove,
    onUp,
    position: state.position,
    isDragging: !!state.startPosition
  };
});